import React from 'react';
import {ItemPresenter} from "../ItemPresenter";

const className = "bearhead";

function GIBearHead() {
  return (
    <ItemPresenter imagePath={`/images/gameItems/${className}.png`} tooltipText={className} />
  );
}

export default GIBearHead;